module.exports = __webpack_public_path__ + "static/media/tomato.c392a271.png";